const formatDateToDDMMYYYY = (dateObj) => {
  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // getMonth() returns months from 0-11
  const year = dateObj.getFullYear();

  return `${day}.${month}.${year}`;
};

export default formatDateToDDMMYYYY;
